msgid ""
msgstr ""
"POT-Creation-Date: 2025-01-29 23:30+0100\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: en\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

msgid "Loading conversation..."
msgstr ""

msgid "Product not found"
msgstr ""

msgid "No categories found"
msgstr ""

msgid "Sent {time} ago"
msgstr ""

msgid "Looking for operators..."
msgstr ""

msgid "View product details"
msgstr ""

msgid "Unknown error"
msgstr ""

msgid "Positive rating"
msgstr ""

msgid "Content is generated using AI. More on <0><1>Kanbu.ai</1></0>"
msgstr ""

msgid "Minimize"
msgstr ""

msgid "No threads found"
msgstr ""

msgid "I only answer questions related to our products and services. I am not intended to answer questions beyond the scope of the content we have specified."
msgstr ""

msgid "Optional field"
msgstr ""

msgid "If I keep answering incorrectly even after clicking \"Start new conversation\" or clarifying the question, I will <0>redirect you to a human operator.</0>"
msgstr ""

msgid "Parsing product details..."
msgstr ""

msgid "{count, plural, one {Found 1 accessory} other {Found # accessories}}"
msgstr ""

msgid "Negative rating"
msgstr ""

msgid "Show less"
msgstr ""

msgid "If the answer is not accurate enough, <0>clarify the question or add all important information </0>(related year, place, categorization, etc.)."
msgstr ""

msgid "Irrelevant"
msgstr ""

msgid "Insufficient detail"
msgstr ""

msgid "Required field"
msgstr ""

msgid "No products found"
msgstr ""

msgid "Specifications"
msgstr ""

#. placeholder {0}: products?.length ?? 0
msgid "{0, plural, one {Found 1 product} other {Found # products}}"
msgstr ""

msgid "We are sorry, but the agent does not exist. Please try again later."
msgstr ""

msgid "Searching..."
msgstr ""

msgid "We were unable to authenticate your request. Please try again later."
msgstr ""

msgid "Switch to AI"
msgstr ""

msgid "No accessories found"
msgstr ""

msgid "Waiting for a response..."
msgstr ""

msgid "Fetching categories..."
msgstr ""

msgid "Looking for accessories..."
msgstr ""

msgid "Ve slevě"
msgstr ""

msgid "Processing your request..."
msgstr ""

msgid "Send"
msgstr ""

msgid "Start new conversation"
msgstr ""

#. placeholder {0}: category.displayName ?? category.name
msgid "Show me products in \"{0}\" category"
msgstr ""

#. placeholder {0}: flatCategories?.length ?? 0
msgid "{0, plural, one {Found 1 category} other {Found # categories}}"
msgstr ""

#. placeholder {0}: hasOperator ? <Trans> or contact physical operator:</Trans> : '.'
msgid "I am sorry but I am currently unavailable. Please try again later{0}"
msgstr ""

msgid "Fetching product details..."
msgstr ""

msgid "{minutes, plural, one {# minute} other {# minutes}}"
msgstr ""

msgid "An error occurred while processing your request"
msgstr ""

msgid "Looking for categories..."
msgstr ""

msgid "Details"
msgstr ""

msgid "Incorrect information"
msgstr ""

msgid "Expected answer or solution..."
msgstr ""

msgid "Included gifts"
msgstr ""

msgid "Feedback"
msgstr ""

msgid "Loading..."
msgstr ""

msgid "(Untitled conversation)"
msgstr ""

msgid "This is a test run and I cannot guarantee the accuracy of the answers yet. Please send your comments and questions to {disclaimerContact}"
msgstr ""

msgid "Help"
msgstr ""

msgid "Deny"
msgstr ""

msgid "Hint"
msgstr ""

msgid "Show more"
msgstr ""

msgid "Accept"
msgstr ""

msgid "Hello, I am Kanbu!"
msgstr ""

msgid "Is this a new topic or are you not satisfied with the answer? Click on this button and try again."
msgstr ""

msgid "Yes, connect me"
msgstr ""

msgid "Previous conversations"
msgstr ""

msgid "Sent just now"
msgstr ""

#. placeholder {0}: args.minPrice
msgid "od {0} Kč"
msgstr ""

msgid "{days, plural, one {# day} other {# days}}"
msgstr ""

msgid "AI has been disconnected, please wait, we're currently looking for free operators..."
msgstr ""

msgid "An error occurred, the chat is currently unavailable. Please try again later."
msgstr ""

msgid "To connect with our operator, please click the button below."
msgstr ""

#. placeholder {0}: args.maxPrice
msgid "do {0} Kč"
msgstr ""

msgid "I <0>only understand text messages.</0> You cannot upload images, voice messages, or ask me to tell you about the content of images from PDF files."
msgstr ""

msgid "We're sorry, but we're currently experiencing issues with our operators. Please try again later."
msgstr ""

msgctxt "page-shortcut"
msgid "p"
msgstr ""

msgid "For the best and most relevant answers, write questions <0>clearly and in complete sentences.</0>"
msgstr ""

msgid "Sources"
msgstr ""

msgid "Recommended accessories"
msgstr ""

msgid "Go back to AI"
msgstr ""

msgid "Hi, I am generative AI chatbot Kanbu, which can help with technical support for customers and knowledge base for employees. I can work with data from the web, database, and documents, and based on this, I can answer immediately, correctly, and authentically! How can I help you?"
msgstr ""

msgid "{hours, plural, one {# hour} other {# hours}}"
msgstr ""

msgid "Talking to human operator"
msgstr ""

msgid "Operator Contact Information"
msgstr ""

msgid "Or you can try to contact us using the contact information below."
msgstr ""

msgid "Ask me anything!"
msgstr ""

#. placeholder {0}: args.query
msgid "\"{0}\""
msgstr ""

msgid " or contact physical operator:"
msgstr ""

msgid "Type your question"
msgstr ""

msgid "Analyzing your request..."
msgstr ""
